<template>
    <LiveSubNav v-if="isOnLive" />
    <SportSubNav v-else />
</template>

<script>
    import { liveTimeFilterSlug } from '@store/modules/ui/shared/timeFilter/utils';
    import LiveSubNav from './LiveSubNav';
    import SportSubNav from './SportSubNav';

    export default {
        computed: {
            isOnLive() {
                return this.$route.params.timeFilter === liveTimeFilterSlug;
            }
        },
        components: {
            LiveSubNav,
            SportSubNav,
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/mobile/sportOffer/SportOfferSubNav.vue